import React from 'react'
import { useSelector } from 'react-redux'
import ContactCard from '../components/ContactCard'
import YesNoAction from '../components/YesNoAction'
import { selectContactInfo } from '../features/azure-b2c/storage'
import { TestIds } from '../testIds'
import { selectRemoteConfig } from '../services/firebase/remote-config/remoteConfig.slice'
import parse, { DOMNode, Element, HTMLReactParserOptions, domToReact } from 'html-react-parser'
import Typography from '../components/Typography'
import { BlockingPage } from './BlockingPages'

export const MaintenancePage = () => {
  const relationshipOwner = useSelector(selectContactInfo)
  const config = useSelector(selectRemoteConfig)

  const options: HTMLReactParserOptions = {
    replace(domNode) {
      const element = domNode as Element
      if (domNode instanceof Element && domNode.attribs) {
        const attribs = element.attribs
        if (domNode.type === 'tag' && domNode.name === 'a') {
          return (
            <Typography
              component='a'
              variant='link'
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              //@ts-ignore
              href={attribs.href}
              fontWeight='600'
              color='primary700'
              {...domNode.attribs}
              {...domNode}
            >
              {domToReact(domNode.children as DOMNode[], options)}
            </Typography>
          )
        }
      }
    },
  }

  return (
    <BlockingPage data-testid={TestIds.pages.maintenancePage}>
      <>
        <YesNoAction
          display={config.maintenanceParams.heading}
          subheading={<Typography variant='h4' sx={{ mt: 3, mb: 2 }}></Typography>}
          body={
            <Typography variant='body2'>
              {parse(config.maintenanceParams.message, options)}
            </Typography>
          }
        />

        <ContactCard
          sx={{ mt: 4 }}
          title={`Contact your Farmlands representative if you are in need of urgent assistance`}
          data-testid={TestIds.components.contactCard.card}
          {...relationshipOwner}
        />
      </>
    </BlockingPage>
  )
}
